import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, Input, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';

import { SnCameraStatus, SnCameraStats } from '@lib/api/entities';
import { SnSize } from '@lib/common/types';

@Component({
  selector: 'sn-camera-stats',
  templateUrl: './camera-stats.component.html',
  styleUrls: ['./camera-stats.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnCameraStatsComponent {
  @Input()
  public stats: SnCameraStats;

  @Input()
  public size: SnSize = 'xs';

  @Input()
  get outlined(): boolean {
    return this._outlined;
  }
  set outlined(value: boolean) {
    this._outlined = coerceBooleanProperty(value);
  }

  @Input()
  get displayLabels(): boolean {
    return this._displayLabels;
  }
  set displayLabels(value: boolean) {
    this._displayLabels = coerceBooleanProperty(value);
  }

  @Input()
  get displayZeroCounts(): boolean {
    return this._displayZeroCounts;
  }
  set displayZeroCounts(value: boolean) {
    this._displayZeroCounts = coerceBooleanProperty(value);
  }

  @Output()
  public readonly itemClick = new EventEmitter<SnCameraStatus>();

  public readonly CAMERAS_STATUS = SnCameraStatus;

  private _outlined = false;
  private _displayLabels = false;
  private _displayZeroCounts = false;

  constructor() {}

  public onChipClick(status: SnCameraStatus): void {
    this.itemClick.emit(status);
  }
}
